import { Card, CardActions, CardContent, Divider, LinearProgress, Typography, Box } from '@mui/material'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import TitleInfoStack from './TitleInfoStack'
import { openConfirmDialog } from 'src/_store/entities/confirmationDialog'
import { useDispatch } from 'react-redux'
import { useSubscripeToPlanMutation } from 'src/_api/planApi'
import { LoadingButton } from '@mui/lab'
import { useNavigate } from 'react-router-dom'

export default function TasksCountCard({
    subscriptionInfo,
    credits,
    hideActions = false
}) {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const progress = (subscriptionInfo?.remainingTasksCount / (subscriptionInfo?.plan?.taskCount + subscriptionInfo?.carriedOverTasks ?? 0)) * 100

    //======= Renew Plan Handler =======
    const [
        subscripeToPlan,
        {
            isLoading: subscripeToPlanLoading,
            isSuccess: subscripeToPlanSuccess,
            error: subscripeToPlanError,
            reset: subscripeToPlanReset,
        },
    ] = useSubscripeToPlanMutation()

    const subscripeToPlanHandler = async () => {
        try {
            await subscripeToPlan({
                planId: subscriptionInfo?.planId?.id,
                subscriptionType: subscriptionInfo?.subscriptionType,
            }).unwrap()

            setTimeout(() => {
                subscripeToPlanReset()
            }, 2000);

        } catch (error) {
            console.log(error)

        }
    }

    const renewPlanHandler = () => {
        let enoughCredits = true

        if (
            subscriptionInfo?.subscriptionType === "MONTHLY" && credits < subscriptionInfo?.planId?.monthlyPrice ||
            subscriptionInfo?.subscriptionType === "YEARLY" && credits < subscriptionInfo?.planId?.yearlyPrice
        ) {
            enoughCredits = false
        }

        let content = enoughCredits ? t("Are you sure you want to renew your subscription now?") : t("You do not have enough credit")

        dispatch(openConfirmDialog({
            title: t("Renew Subscription"),
            content: content,
            confirmBtnTitle: enoughCredits ? t("Confirm") : t("Charge Wallet"),
            onConfirm: () => {
                if (enoughCredits) {
                    navigate(`/merchant/account/plan-checkout/${subscriptionInfo?.planId?.id}/${subscriptionInfo?.subscriptionType}?subscribe=renew`)
                } else {
                    navigate("/merchant/balance")
                }
            }
        })
        )
    }

    return (
        <Card>
            <CardContent>
                <Typography variant="h3">
                    {t("Tasks Usage")}
                </Typography>
                <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={2} my={4}>
                    <TitleInfoStack
                        title={t('Plan Tasks')}
                        elementValue={
                            <Box display="flex" alignItems="center" gap={1}>
                                <Typography fontWeight="bold">
                                    {subscriptionInfo?.plan?.taskCount}
                                </Typography>
                                <Typography variant='body2' fontWeight="bold" color="text.lighter">
                                    {` / ${t('Monthly')}`}
                                </Typography>
                            </Box>
                        }
                        direction='row'
                    />
                    {!!subscriptionInfo?.carriedOverTasks &&
                        <TitleInfoStack
                            title={t('Previously Leftover Tasks')}
                            value={subscriptionInfo?.carriedOverTasks}
                        />
                    }
                </Box>
                <LinearProgress variant="determinate" value={Math.ceil(progress)} size={100} />
                <TitleInfoStack
                    title={t('Remaining Tasks')}
                    value={subscriptionInfo?.remainingTasksCount}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ mt: 3 }}
                />

            </CardContent>
            {
                !hideActions &&
                <>
                    <Divider />
                    <CardActions>
                        {subscripeToPlanSuccess && <Typography color="success.main">{t("Done successfully")}</Typography>}
                        {!!subscripeToPlanError && <Typography color="error">{subscripeToPlanError}</Typography>}
                        <Box mr="auto" />
                        <LoadingButton
                            sx={{ textTransform: "none" }}
                            variant="contained"
                            onClick={renewPlanHandler}
                            loading={subscripeToPlanLoading}
                        //disabled={subscriptionInfo?.remainingTasksCount > 0}
                        >
                            {t("Renew")}
                        </LoadingButton>
                    </CardActions>
                </>
            }
        </Card>
    )
}
